import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=9ea3b578&"
import script from "./Partners.vue?vue&type=script&setup=true&lang=js&"
export * from "./Partners.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports